module.exports = __webpack_public_path__ + "img/diente73.f6df4afb.png";